<template>
  <vue-datepicker-local format="YYYY-MM-DD" clearable :local="schema.local" v-model="value"></vue-datepicker-local>
</template>
<script>
  import { abstractField } from 'vue-form-generator/dist/vfg.js'
  import VueDatepickerLocal from 'vue-datepicker-local'

  export default {
    mixins: [ abstractField ],
    components: {
      VueDatepickerLocal
    }
  }
</script>


// WEBPACK FOOTER //
// VfgDatePicker.vue?2afedc2c